import { useTranslation } from "react-i18next";

const useProductTranslations = () => {
  const { t, ...rest } = useTranslation("products");

  return {
    ...rest,
    t,
  };
};

export default useProductTranslations;
